import { GET_CLIENT_EMPLOYEE_APPS_LICENSES_DETAILS } from "../../constant/Apipath";
import { Getrequestcall } from "../../request/Getrequest";

export const getClientEmployeeAppsLicensesDetailsPath = (clientId, employeeId) =>
  `${GET_CLIENT_EMPLOYEE_APPS_LICENSES_DETAILS}/${clientId}/${employeeId}`;

export const normalizeClientEmployeeAppsLicensesResponse = (response) => {
  const responseData = response?.data || {};
  const data = responseData?.Data || {};
  const apps = Array.isArray(data?.apps) ? data?.apps : Array.isArray(data) ? data : [];
  const licenses = Array.isArray(data?.licenses) ? data.licenses : [];

  return {
    ...response,
    data: {
      ...responseData,
      data: apps,
      apps,
      licenses
    }
  };
};

export const isMatchingClientEmployeeAppsLicensesResponse = (response, clientId, employeeId) => {
  if (!response?.status || !Array.isArray(response?.data?.data)) return false;

  const firstItem = response.data.data[0];
  const responseClientId = firstItem?.ClientId ?? firstItem?.clientId;
  const responseEmployeeId = firstItem?.EmployeeId ?? firstItem?.employeeId;

  return String(responseClientId) === String(clientId) && String(responseEmployeeId) === String(employeeId);
};

export const fetchClientEmployeeAppsLicensesDetails = async (clientId, employeeId, token) => {
  return Getrequestcall(getClientEmployeeAppsLicensesDetailsPath(clientId, employeeId), token);
};
